var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodataContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.5,
    height: 116,
    viewBox: "0 0 137.5 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Adult_talking_cell_phone-rafiki_2_",
    "data-name": "Adult talking cell phone-rafiki (2)",
    transform: "translate(0 -45.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-166",
    transform: "translate(0 45.3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    width: 137.5,
    height: 0.069,
    transform: "translate(0 92.702)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    width: 9.108,
    height: 0.069,
    transform: "translate(114.614 97.127)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    width: 2.39,
    height: 0.069,
    transform: "translate(88.695 97.875)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 5.277,
    height: 0.069,
    transform: "translate(109.062 94.575)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    width: 11.877,
    height: 0.069,
    transform: "translate(14.426 95.037)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    width: 1.741,
    height: 0.069,
    transform: "translate(28.754 95.037)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    width: 25.762,
    height: 0.069,
    transform: "translate(36.154 96.197)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M92.877,132.77h-53.1a1.57,1.57,0,0,1-1.567-1.57V56.556A1.57,1.57,0,0,1,39.777,55h53.1a1.57,1.57,0,0,1,1.57,1.57V131.2A1.57,1.57,0,0,1,92.877,132.77Zm-53.1-77.715a1.5,1.5,0,0,0-1.5,1.5V131.2a1.5,1.5,0,0,0,1.5,1.5h53.1a1.5,1.5,0,0,0,1.5-1.5V56.556a1.5,1.5,0,0,0-1.5-1.5Z",
    transform: "translate(-27.702 -52.333)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M309.173,132.77h-53.1a1.573,1.573,0,0,1-1.57-1.57V56.556A1.573,1.573,0,0,1,256.07,55h53.1a1.57,1.57,0,0,1,1.565,1.556V131.2A1.57,1.57,0,0,1,309.173,132.77Zm-53.1-77.715a1.5,1.5,0,0,0-1.5,1.5V131.2a1.5,1.5,0,0,0,1.5,1.5h53.1a1.5,1.5,0,0,0,1.5-1.5V56.556a1.5,1.5,0,0,0-1.5-1.5Z",
    transform: "translate(-184.513 -52.333)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 6.064,
    cy: 6.064,
    r: 6.064,
    transform: "translate(7.4 46.563)",
    fill: "#e6f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M43.168,228.722a2.772,2.772,0,0,0-.825-1.969l-.957-.96-.072-.069-1.034-1.034a2.794,2.794,0,0,0-3.938,0,3.152,3.152,0,0,0-.223.256l1.7,1.708.932-.932a.476.476,0,0,1,.671,0l.96.94.069.069.869.869a.476.476,0,0,1,0,.671l-.932.932,1.7,1.705a2.7,2.7,0,0,0,1.07-2.2Z",
    transform: "translate(-26.187 -174.769)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 7.848,
    cy: 7.848,
    r: 7.848,
    transform: "translate(34.972 7.12)",
    fill: "#e6f8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_717",
    "data-name": "Rectangle 717",
    width: 7.708,
    height: 5.431,
    rx: 1.8,
    transform: "translate(37.832 12.251)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M169.514,97.194,167.87,96.6V94.694l1.645-.594Z",
    transform: "translate(-121.706 -80.68)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 7.384,
    cy: 7.384,
    r: 7.384,
    transform: "translate(114.125 33.894)",
    fill: "#e6f8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_718",
    "data-name": "Rectangle 718",
    width: 7.249,
    height: 5.107,
    rx: 1.8,
    transform: "translate(116.814 38.723)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M454.828,193.019l-1.548-.558v-1.8l1.548-.556Z",
    transform: "translate(-328.628 -150.287)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 8.885,
    cy: 8.885,
    r: 8.885,
    transform: "translate(87.516)",
    fill: "#e6f8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_719",
    "data-name": "Rectangle 719",
    width: 2.236,
    height: 3.685,
    transform: "translate(91.247 7.043)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M342.455,71.568l-3.875-2.027V66.217l3.875-2.027Z",
    transform: "translate(-245.471 -58.995)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_720",
    "data-name": "Rectangle 720",
    width: 2.981,
    height: 0.437,
    transform: "translate(98.576 8.665)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_721",
    "data-name": "Rectangle 721",
    width: 3,
    height: 0.437,
    transform: "matrix(0.882, -0.472, 0.472, 0.882, 98.037, 6.148)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_722",
    "data-name": "Rectangle 722",
    width: 0.437,
    height: 3,
    transform: "translate(98.04 11.628) rotate(-61.84)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 6.006,
    cy: 6.006,
    r: 6.006,
    transform: "translate(107.725 66.619) rotate(-9.22)",
    fill: "#e6f8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_723",
    "data-name": "Rectangle 723",
    width: 2.786,
    height: 4.603,
    rx: 1.393,
    transform: "translate(113.22 68.335)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M411.092,305.383a2.159,2.159,0,0,1-2.156-2.156v-.855a.192.192,0,1,1,.382,0v.855a1.774,1.774,0,0,0,3.545,0v-.855a.193.193,0,0,1,.385,0v.855A2.159,2.159,0,0,1,411.092,305.383Z",
    transform: "translate(-296.478 -231.521)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M416.272,314.052a.193.193,0,0,1-.193-.193v-1.177a.193.193,0,0,1,.385,0v1.177A.193.193,0,0,1,416.272,314.052Z",
    transform: "translate(-301.658 -239.013)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M410.825,299.846a.184.184,0,0,1-.135-.058l-6.66-6.663a.194.194,0,1,1,.275-.275l6.66,6.66a.19.19,0,0,1,0,.275A.184.184,0,0,1,410.825,299.846Z",
    transform: "translate(-292.881 -224.733)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 6.363,
    cy: 6.363,
    r: 6.363,
    transform: "translate(44.12 51.562) rotate(-13.28)",
    fill: "#e6f8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_724",
    "data-name": "Rectangle 724",
    width: 2.951,
    height: 4.878,
    rx: 1.475,
    transform: "translate(50.3 52.841)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M182.378,249.873a2.241,2.241,0,0,1-2.238-2.238v-.908a.157.157,0,0,1,.157-.157.16.16,0,0,1,.157.157v.908a1.925,1.925,0,0,0,3.85,0v-.908a.16.16,0,0,1,.157-.157.157.157,0,0,1,.157.157v.908A2.241,2.241,0,0,1,182.378,249.873Z",
    transform: "translate(-130.602 -191.221)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M187.867,258.995a.157.157,0,0,1-.157-.157v-1.251a.157.157,0,0,1,.157-.157.16.16,0,0,1,.157.157v1.248a.16.16,0,0,1-.157.16Z",
    transform: "translate(-136.09 -199.094)",
    fill: "#c2e5f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M182.059,243.964a.151.151,0,0,1-.11-.044l-7.07-7.059a.158.158,0,0,1,.223-.223l7.056,7.059a.16.16,0,0,1,0,.223A.157.157,0,0,1,182.059,243.964Z",
    transform: "translate(-126.754 -183.987)",
    fill: "#c2e5f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-166",
    transform: "translate(14.869 143.568)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-166",
    cx: 53.32,
    cy: 8.866,
    rx: 53.32,
    ry: 8.866,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-166",
    transform: "translate(51.307 58.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M204.481,93a17.911,17.911,0,1,0,17.911,17.91A17.911,17.911,0,0,0,204.481,93Zm9.729,25.9a8.25,8.25,0,0,1-11.63,0l-3.055-3.058-.206-.206-2.832-2.841a8.25,8.25,0,0,1,0-11.63,9.9,9.9,0,0,1,.762-.66l5.041,5.041-2.75,2.75a1.4,1.4,0,0,0,0,1.985l2.563,2.563.2.206,2.791,2.788a1.4,1.4,0,0,0,1.983,0l2.75-2.75,5.041,5.041a9.37,9.37,0,0,1-.66.762Z",
    transform: "translate(-186.57 -93)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M204.481,93a17.911,17.911,0,1,0,17.911,17.91A17.911,17.911,0,0,0,204.481,93Zm9.729,25.9a8.25,8.25,0,0,1-11.63,0l-3.055-3.058-.206-.206-2.832-2.841a8.25,8.25,0,0,1,0-11.63,9.9,9.9,0,0,1,.762-.66l5.041,5.041-2.75,2.75a1.4,1.4,0,0,0,0,1.985l2.563,2.563.2.206,2.791,2.788a1.4,1.4,0,0,0,1.983,0l2.75-2.75,5.041,5.041a9.37,9.37,0,0,1-.66.762Z",
    transform: "translate(-186.57 -93)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-4--inject-166",
    transform: "translate(99.825 68.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M366.388,128.18h9.886a3.4,3.4,0,0,1,3.4,3.4v4.1a3.4,3.4,0,0,1-3.4,3.4h-6.8l-2.241,2.12-.047-2.12h-.8a3.4,3.4,0,0,1-3.388-3.4v-4.1a3.4,3.4,0,0,1,3.388-3.4Z",
    transform: "translate(-363 -128.18)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1337",
    "data-name": "Group 1337",
    transform: "translate(0 0)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M366.388,128.18h9.886a3.4,3.4,0,0,1,3.4,3.4v4.1a3.4,3.4,0,0,1-3.4,3.4h-6.8l-2.241,2.12-.047-2.12h-.8a3.4,3.4,0,0,1-3.388-3.4v-4.1a3.4,3.4,0,0,1,3.388-3.4Z",
    transform: "translate(-363 -128.18)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M407.3,145.337a.685.685,0,1,0,.2-.487A.688.688,0,0,0,407.3,145.337Z",
    transform: "translate(-395.117 -140.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 0.687,
    cy: 0.687,
    r: 0.687,
    transform: "translate(9.155 4.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M385.29,145.337a.685.685,0,1,0,.2-.487.687.687,0,0,0-.2.487Z",
    transform: "translate(-379.16 -140.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 0.687,
    cy: 0.687,
    r: 0.687,
    transform: "translate(3.105 4.529)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-166",
    transform: "translate(18.425 63.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M78.275,112.59H69.893A2.882,2.882,0,0,0,67,115.475v3.481a2.882,2.882,0,0,0,2.885,2.885H75.66l1.9,1.8.041-1.8h.674a2.885,2.885,0,0,0,2.887-2.885v-3.481a2.885,2.885,0,0,0-2.887-2.885Z",
    transform: "translate(-67 -112.59)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M77.816,127.153a.583.583,0,1,1-.583-.583A.583.583,0,0,1,77.816,127.153Z",
    transform: "translate(-73.996 -122.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 0.583,
    cy: 0.583,
    r: 0.583,
    transform: "translate(5.222 3.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M96.5,127.153a.583.583,0,1,1-.583-.583A.583.583,0,0,1,96.5,127.153Z",
    transform: "translate(-87.539 -122.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 0.583,
    cy: 0.583,
    r: 0.583,
    transform: "translate(10.359 3.845)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-166",
    transform: "translate(88.083 83.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M357.976,279.575c-1.034-3.712-17.465.742-17.465.742a32.333,32.333,0,0,0-.5,7.477h0c-.206,4.5.806,8.654,1.029,12.977-.872,5.86.225,14.168.225,14.168l4,.506s2.373-9.4,3.333-14.437c.237-1.243.512-2.767.789-4.342a41.975,41.975,0,0,1,1.207,4.433c-.058,5.923,2.167,14,2.167,14l4.026-.047s1.064-9.639,1.32-14.759c.179-3.531.275-9.471.333-12.548A24.948,24.948,0,0,0,357.976,279.575Z",
    transform: "translate(-334.544 -252.446)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M357.976,279.575c-1.034-3.712-17.465.742-17.465.742a32.333,32.333,0,0,0-.5,7.477h0c-.206,4.5.806,8.654,1.029,12.977-.872,5.86.225,14.168.225,14.168l4,.506s2.373-9.4,3.333-14.437c.237-1.243.512-2.767.789-4.342a41.975,41.975,0,0,1,1.207,4.433c-.058,5.923,2.167,14,2.167,14l4.026-.047s1.064-9.639,1.32-14.759c.179-3.531.275-9.471.333-12.548A24.948,24.948,0,0,0,357.976,279.575Z",
    transform: "translate(-334.544 -252.446)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M390.444,406.63l-3.514.091.36,4.147,2.937-.072Z",
    transform: "translate(-368.608 -345.631)",
    fill: "#d9877c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M390.437,406.63l-3.517.094.2,2.321,3.193-.08Z",
    transform: "translate(-368.6 -345.631)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M384.62,408.06l4.351-.038a.154.154,0,0,0,.151-.135l.2-1.6a.149.149,0,0,0-.16-.171l-4.848.327a.157.157,0,0,0-.137.187l.3,1.309A.146.146,0,0,0,384.62,408.06Z",
    transform: "translate(-366.606 -345.26)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M386.3,419.627a.168.168,0,0,1,.209-.138,7.182,7.182,0,0,0,3.187-.038.525.525,0,0,1,.407.082,8.326,8.326,0,0,0,2.475.77,1.974,1.974,0,0,1,.088,1.059H385.93A11.926,11.926,0,0,0,386.3,419.627Z",
    transform: "translate(-367.883 -354.918)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M349.094,407.538l-3.49-.418-.245,4.155,2.918.352Z",
    transform: "translate(-338.469 -345.987)",
    fill: "#d9877c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M349.37,407.538l-3.492-.418-.137,2.326,3.173.382Z",
    transform: "translate(-338.745 -345.987)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M343.346,408.139l4.317.55a.151.151,0,0,0,.165-.11l.415-1.559a.151.151,0,0,0-.137-.19l-4.846-.341a.151.151,0,0,0-.162.165l.116,1.339A.148.148,0,0,0,343.346,408.139Z",
    transform: "translate(-336.829 -345.529)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M344.021,419.627a.165.165,0,0,1,.206-.137,7.2,7.2,0,0,0,3.19-.039.52.52,0,0,1,.4.082,8.348,8.348,0,0,0,2.475.77,1.994,1.994,0,0,1,.091,1.059H343.65A11.744,11.744,0,0,0,344.021,419.627Z",
    transform: "translate(-337.23 -354.918)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M384.62,408.06l4.351-.038a.154.154,0,0,0,.151-.135l.2-1.6a.149.149,0,0,0-.16-.171l-4.848.327a.157.157,0,0,0-.137.187l.3,1.309A.146.146,0,0,0,384.62,408.06Z",
    transform: "translate(-366.606 -345.26)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M343.346,408.139l4.317.55a.151.151,0,0,0,.165-.11l.415-1.559a.151.151,0,0,0-.137-.19l-4.846-.341a.151.151,0,0,0-.162.165l.116,1.339A.148.148,0,0,0,343.346,408.139Z",
    transform: "translate(-336.829 -345.529)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M340.264,290.39l-.324,1.037a59.669,59.669,0,0,0,9.834,2.692l1.65-1.466,1.193,1.466s4.581-.622,6.105-1.865l-.371-2.365Z",
    transform: "translate(-334.54 -260.995)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M340.264,290.39l-.324,1.037a59.669,59.669,0,0,0,9.834,2.692l1.65-1.466,1.193,1.466s4.581-.622,6.105-1.865l-.371-2.365Z",
    transform: "translate(-334.54 -260.995)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M377.429,211.875a16.671,16.671,0,0,0,7.084-.069l-.965.786a1.71,1.71,0,0,0,.03,1.969c.058.044.055,0,.022-.033a1.162,1.162,0,0,0-.168-.184,40.176,40.176,0,0,0-4.579-2.841,1.356,1.356,0,0,1,.776-2.508,17.978,17.978,0,0,1,2.063.258,16.856,16.856,0,0,1,3.1.842c1.424.6,2.75,1.273,3.165,3.074a2.785,2.785,0,0,1-1.474,3.025,15.762,15.762,0,0,1-10.321.858,2.672,2.672,0,0,1,1.259-5.192Z",
    transform: "translate(-359.362 -202.346)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M386.192,230.621c-.388.049-.773.088-1.155.11s-.841.036-1.262.033-.839-.017-1.26-.055-.841-.074-1.265-.143a12.737,12.737,0,0,1-1.32-.275,2.55,2.55,0,0,1-.55-.209,8.539,8.539,0,0,1,.825-2.852A10.18,10.18,0,0,1,386.192,230.621Z",
    transform: "translate(-363.134 -215.566)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M381.536,202.97l-1.009,1.1c-1.4.7-1.983-1.254-1.983-1.254l-.979-1.18a.789.789,0,0,1,.1-1.018l.7-.767a.825.825,0,0,1,1.138-.14l1,.971a1.628,1.628,0,0,1,.443.657Z",
    transform: "translate(-361.715 -195.495)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M387.006,211.219l-.756-.41a9.837,9.837,0,0,0,1.507-2.417l1.067-.1S388.609,210.479,387.006,211.219Z",
    transform: "translate(-368.115 -201.835)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M387.006,211.219l-.756-.41a9.837,9.837,0,0,0,1.507-2.417l1.067-.1S388.609,210.479,387.006,211.219Z",
    transform: "translate(-368.115 -201.835)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M335.272,223.614c1.1,4.048,1.174,8.852,1.433,12.276,0,0-.63,2.23.022,3.374,0,0,11.168,3.36,18.373.294a23.547,23.547,0,0,0,.072-4.455c-.421-5.632-3.182-9.71-4.876-14.734a2.9,2.9,0,0,0-2.75-1.691,44.329,44.329,0,0,0-9.782.825,3.3,3.3,0,0,0-2.491,4.111Z",
    transform: "translate(-331.068 -209.354)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M358.288,213.393c-1.889.3-3.71-1.144-4.658-1.609.888-.776.319-2.027.437-2.714.052-.305.066-.5.066-.5l4.276,1.1a1.958,1.958,0,0,0,.041,1.3,1.732,1.732,0,0,1,.99.825.13.13,0,0,0,.014.028C359.762,212.445,360.15,213.088,358.288,213.393Z",
    transform: "translate(-344.465 -202.038)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M360.607,211.8c-1.837,1-4.865-1.122-5.387-2.75.052-.305.066-.5.066-.5l4.276,1.1a1.958,1.958,0,0,0,.041,1.3,1.732,1.732,0,0,1,.99.825A.128.128,0,0,0,360.607,211.8Z",
    transform: "translate(-345.618 -202.023)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M366.171,224.55l-.784-.55-1.048.671S365.008,225.224,366.171,224.55Z",
    transform: "translate(-352.23 -213.225)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M366.171,224.55l-.784-.55-1.048.671S365.008,225.224,366.171,224.55Z",
    transform: "translate(-352.23 -213.225)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M352.935,218.35a4.916,4.916,0,0,0,3.575,1.554,3.165,3.165,0,0,0-1.375,2.087,3.944,3.944,0,0,1-3.025-3.124A1.1,1.1,0,0,1,352.935,218.35Z",
    transform: "translate(-343.363 -209.128)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M371,223.571l.88-.921,1.128.2A1.978,1.978,0,0,1,371,223.571Z",
    transform: "translate(-357.058 -212.246)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M371,223.571l.88-.921,1.128.2A1.978,1.978,0,0,1,371,223.571Z",
    transform: "translate(-357.058 -212.246)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M371.16,217.164a3.157,3.157,0,0,1,.825,1.488c.946.151,1.408,1.5,1.408,1.5a3.336,3.336,0,0,0-1.326-2.931A1.51,1.51,0,0,0,371.16,217.164Z",
    transform: "translate(-357.174 -208.236)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M352.935,218.35a4.916,4.916,0,0,0,3.575,1.554,3.165,3.165,0,0,0-1.375,2.087,3.944,3.944,0,0,1-3.025-3.124A1.1,1.1,0,0,1,352.935,218.35Z",
    transform: "translate(-343.363 -209.128)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M371.16,217.164a3.157,3.157,0,0,1,.825,1.488c.946.151,1.408,1.5,1.408,1.5a3.336,3.336,0,0,0-1.326-2.931A1.51,1.51,0,0,0,371.16,217.164Z",
    transform: "translate(-357.174 -208.236)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M335.59,236.67c1.1,4.048,1.174,8.852,1.433,12.276a11.426,11.426,0,0,0,3.3.181c3.025-.132,5.69-2.868,4.012-3.49-2.428-.9-6.025-1.925-6.025-1.925a18.853,18.853,0,0,0,.536-5.225Z",
    transform: "translate(-331.386 -222.41)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M328.819,227.5c.115-.093.082-.069.066-.044l-.107.137a23.5,23.5,0,0,0-3.371,6.05,5.642,5.642,0,0,0-.146.619c0,.052-.014.066-.039.019a1.411,1.411,0,0,0-.154-.242c-.072-.107-.275-.248-.25-.2a5.628,5.628,0,0,0,2.038.721c1.474.327,3.13.531,4.727.781a1.348,1.348,0,0,1,.193,2.64,22.189,22.189,0,0,1-3.943.655c-4.447.385-8.39-.825-7.365-6.143a17.254,17.254,0,0,1,1.512-4.155,20.826,20.826,0,0,1,2.951-4.5,2.737,2.737,0,0,1,4.273-.1,2.668,2.668,0,0,1-.385,3.756Z",
    transform: "translate(-320.303 -212.326)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M360.379,268.334l-.459,1.334c.044,1.482,1.939,1.1,1.939,1.1l.987.181a.748.748,0,0,0,.808-.533l.327-.932a.778.778,0,0,0-.393-1.012l-.825-.3a1.54,1.54,0,0,0-.748-.077Z",
    transform: "translate(-349.025 -245.184)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M357.674,267.35l.913.369a6.4,6.4,0,0,0-.908,2.475l-1.18.786S356.192,268.323,357.674,267.35Z",
    transform: "translate(-346.527 -244.653)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M357.674,267.35l.913.369a6.4,6.4,0,0,0-.908,2.475l-1.18.786S356.192,268.323,357.674,267.35Z",
    transform: "translate(-346.527 -244.653)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M372.688,195.627l1.5-1.617-.074-.083a1.161,1.161,0,0,1,.209,0,.173.173,0,0,1,.143.1l2.725,4.482a.275.275,0,0,1,0,.324l-1.532,1.65a.116.116,0,0,1-.088.041h-.217l.039-.138-2.7-4.441A.275.275,0,0,1,372.688,195.627Z",
    transform: "translate(-358.246 -191.419)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M374.9,200.509l1.534-1.65a.275.275,0,0,0,0-.324l-2.728-4.482c-.063-.1-.17-.129-.239-.055l-1.535,1.65a.275.275,0,0,0,0,.324l2.731,4.485A.141.141,0,0,0,374.9,200.509Z",
    transform: "translate(-357.695 -191.441)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M374.9,200.509l1.534-1.65a.275.275,0,0,0,0-.324l-2.728-4.482c-.063-.1-.17-.129-.239-.055l-1.535,1.65a.275.275,0,0,0,0,.324l2.731,4.485A.141.141,0,0,0,374.9,200.509Z",
    transform: "translate(-357.695 -191.441)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M375.181,200.836,376.7,199.2a.135.135,0,0,0,0-.16l-2.643-4.348c-.033-.052-.085-.063-.118-.027l-1.518,1.65a.14.14,0,0,0,0,.157l2.645,4.35A.076.076,0,0,0,375.181,200.836Z",
    transform: "translate(-358.068 -191.942)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1339",
    "data-name": "Group 1339",
    transform: "translate(14.762 3.34)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M374.056,198.374a.088.088,0,0,0,.055-.022l1.169-1.265a.074.074,0,0,0,0-.1.077.077,0,0,0-.107,0L374,198.248a.074.074,0,0,0,0,.1A.077.077,0,0,0,374.056,198.374Z",
    transform: "translate(-373.982 -196.961)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M378.032,203.793a.627.627,0,0,0,.426.319.415.415,0,0,0,.371-.14.756.756,0,0,0,.19-.454,1.059,1.059,0,0,0-.146-.619c-.209-.346-.567-.426-.795-.179a.951.951,0,0,0-.047,1.072Z",
    transform: "translate(-362.053 -197.693)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M379.2,205.019l.016.028a.415.415,0,0,0,.371-.14.756.756,0,0,0,.19-.451l-.017-.028a.349.349,0,0,0-.426-.19.38.38,0,0,0-.05-.253c-.077-.124-.206-.154-.289-.063a.341.341,0,0,0,0,.388.217.217,0,0,0,.173.118A.674.674,0,0,0,379.2,205.019Z",
    transform: "translate(-362.815 -198.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M381.23,210.609l1.452-1.57a.094.094,0,0,0,0-.107l-.391-.641a.049.049,0,0,0-.08-.017l-1.447,1.565a.093.093,0,0,0,0,.107l.391.641a.049.049,0,0,0,.074.022Z",
    transform: "translate(-364.126 -201.813)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1340",
    "data-name": "Group 1340",
    transform: "translate(15.437 4.172)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M376.478,200.322a.039.039,0,0,0,.028-.014l.242-.261a.037.037,0,1,0-.055-.05l-.242.261a.036.036,0,0,0,0,.052.041.041,0,0,0,.027.011Z",
    transform: "translate(-376.439 -199.985)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M381.938,214.234c.052.088.143.107.2.047a.239.239,0,0,0,0-.275c-.052-.088-.143-.107-.2-.044A.239.239,0,0,0,381.938,214.234Z",
    transform: "translate(-364.958 -205.92)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M383.2,212.865c.052.088.14.107.2.044a.234.234,0,0,0,0-.275c-.052-.088-.14-.107-.2-.047A.234.234,0,0,0,383.2,212.865Z",
    transform: "translate(-365.87 -204.925)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M384.465,211.512c.052.085.14.107.2.044a.239.239,0,0,0,0-.275c-.052-.085-.14-.1-.2-.044A.239.239,0,0,0,384.465,211.512Z",
    transform: "translate(-366.789 -203.946)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M385.725,210.179c.052.085.14.1.2.044a.239.239,0,0,0,0-.275c-.052-.085-.14-.107-.2-.044A.239.239,0,0,0,385.725,210.179Z",
    transform: "translate(-367.703 -202.979)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M364.086,187.66a2.374,2.374,0,0,1,1.562.632c.476.6,1.405,2.964.759,3.36s-2.764.063-3.025-.773S364.086,187.66,364.086,187.66Z",
    transform: "translate(-351.503 -186.878)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M350.706,191.9c.732,2.118,1.276,3.539,2.874,4.125,3.176,1.185,4.469-.36,4.436-2.64-.028-2.054-1.216-5.173-3.729-5.481A3.131,3.131,0,0,0,350.706,191.9Z",
    transform: "translate(-342.226 -187.033)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M361.655,200.715a1.1,1.1,0,0,0-.825.165,2.2,2.2,0,0,0,.825-.165Z",
    transform: "translate(-349.685 -196.328)",
    fill: "#d58745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M362.11,201.5a.916.916,0,0,0-.69.333A1.8,1.8,0,0,0,362.11,201.5Z",
    transform: "translate(-350.113 -196.912)",
    fill: "#d58745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M364.66,192.06a10.279,10.279,0,0,0-2.09.341C363.741,192.252,364.66,192.06,364.66,192.06Z",
    transform: "translate(-350.947 -190.068)",
    fill: "#d58745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M365.278,192.69a10.245,10.245,0,0,0-2.318.668,19.178,19.178,0,0,0,2.318-.668Z",
    transform: "translate(-351.229 -190.525)",
    fill: "#d58745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M366.308,199.451c.047.19.187.316.311.275s.184-.212.138-.4-.187-.316-.311-.275S366.262,199.261,366.308,199.451Z",
    transform: "translate(-353.646 -195.13)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M373.485,197.829c.047.19.184.319.308.275a.323.323,0,0,0,.14-.4c-.047-.19-.187-.319-.311-.275A.32.32,0,0,0,373.485,197.829Z",
    transform: "translate(-358.848 -193.953)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M361.844,197.242a.107.107,0,0,1-.058,0,.115.115,0,0,1-.06-.151,1.169,1.169,0,0,1,.792-.7.113.113,0,0,1,.132.094.118.118,0,0,1-.091.135h0a.913.913,0,0,0-.622.55.115.115,0,0,1-.094.069Z",
    transform: "translate(-350.328 -193.209)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M373.079,194.964a.115.115,0,0,1-.1-.027.9.9,0,0,0-.786-.253.11.11,0,0,1-.138-.083.116.116,0,0,1,.083-.14,1.133,1.133,0,0,1,1,.308.116.116,0,0,1,0,.162A.124.124,0,0,1,373.079,194.964Z",
    transform: "translate(-357.817 -191.795)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M368.093,207.83a16.087,16.087,0,0,0-3.083.462,1.827,1.827,0,0,0,2.161.809,1.067,1.067,0,0,0,.921-1.27Z",
    transform: "translate(-352.716 -201.501)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M368.744,210.737a2.131,2.131,0,0,1,1.32.061,1.257,1.257,0,0,1-.674.355,2.115,2.115,0,0,1-1.32-.06,1.24,1.24,0,0,1,.674-.355Z",
    transform: "translate(-354.934 -203.553)",
    fill: "#a02724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M368.254,207.83a.473.473,0,0,1-.275.41,11.952,11.952,0,0,1-2.021.253.643.643,0,0,1-.577-.223A19.146,19.146,0,0,1,368.254,207.83Z",
    transform: "translate(-352.984 -201.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M350.709,184.834c-.759-.171-3.751.921-4.364,2.475a4.18,4.18,0,0,0,.825,4.4,14.724,14.724,0,0,0,2.06.138c1.009-.016.572-2.8-.135-3.393l-.151-.069c-.39-.19-1.037-.58-1.064-.825a2.552,2.552,0,0,1,1.548-1.441c.663-.066,1.48.1,1.892.028a2.7,2.7,0,0,0,.652-.187A2.4,2.4,0,0,0,350.709,184.834Z",
    transform: "translate(-338.967 -184.816)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M349.144,207.026a2.258,2.258,0,0,0,1.625.624c.8-.03.965-.806.55-1.438-.38-.566-1.251-1.235-1.961-.9A1.028,1.028,0,0,0,349.144,207.026Z",
    transform: "translate(-340.95 -199.611)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M358.7,204.82a4.333,4.333,0,0,0,.446,1.24c.217.217.718-.7.954-.957s1.958-.055,1.958-.055a1.028,1.028,0,0,1,.014.217,14.167,14.167,0,0,1-1.843.335c-.2-.025-.707.938.1,1.551a1.751,1.751,0,0,0,1.732.434c.261-.14.049-.577.049-.577l.5-.11s.038.437.294.528.6-1.028.627-1.65-.311-.781-1.067-.525l-.083-.319a4.405,4.405,0,0,1,1.07-.418,2.6,2.6,0,0,1,.484,1.837,2.231,2.231,0,0,1-1.724,2.183,4.464,4.464,0,0,1-3.4-.633c-.814-.608-.385-1.941-.385-1.941Z",
    transform: "translate(-347.858 -199.094)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M371.29,200.06l.388,1.6a1.835,1.835,0,0,0,.566-.115.215.215,0,0,0,.027-.38A3.822,3.822,0,0,1,371.29,200.06Z",
    transform: "translate(-357.269 -195.868)",
    fill: "#d58745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M374.26,328.1l1.059-6.644s.9,7.975.014,10.433C375.079,330.865,374.26,328.1,374.26,328.1Z",
    transform: "translate(-359.422 -283.883)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-166",
    transform: "translate(18.607 74.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M94.116,395.19c-.151,1.375-.275,5.362-.586,6.325.55,1.056,1.345,1.287,1.853.671s1.493-5.948,1.493-5.948Z",
    transform: "translate(-86.416 -328.389)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M79.776,415.935s3.336-.982,3.575-2.3a.228.228,0,0,1,.275-.192l2.423.407a.322.322,0,0,1,.248.215l.187,2.357-1.51.022-.19-.159-1.177.176c-3.718.118-3.124.126-3.869-.083C79.614,416.07,79.776,415.935,79.776,415.935Z",
    transform: "translate(-76.383 -341.621)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M90.577,281.614c.462,6.861.55,18.389.55,18.389l3.261.143a85.681,85.681,0,0,0,1.9-14.5q.033-1.042.03-2.087a106.9,106.9,0,0,1,2.651-12.1c.809-2.953,1.521-5.3,1.906-7.549l-9.625-3.127C90.7,262.466,89.776,269.7,90.577,281.614Z",
    transform: "translate(-84.049 -230.941)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M90.577,281.614c.462,6.861.55,18.389.55,18.389l3.261.143a85.681,85.681,0,0,0,1.9-14.5q.033-1.042.03-2.087a106.9,106.9,0,0,1,2.651-12.1c.809-2.953,1.521-5.3,1.906-7.549l-9.625-3.127C90.7,262.466,89.776,269.7,90.577,281.614Z",
    transform: "translate(-84.049 -230.941)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M95.451,403.772a10.141,10.141,0,0,1-3.094-.589c-.4-.245-.146-1.856-.146-1.856s3.481-.033,3.745.275S95.451,403.772,95.451,403.772Z",
    transform: "translate(-85.403 -332.837)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M95.451,403.772a10.141,10.141,0,0,1-3.094-.589c-.4-.245-.146-1.856-.146-1.856s3.481-.033,3.745.275S95.451,403.772,95.451,403.772Z",
    transform: "translate(-85.403 -332.837)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M105.952,298.917q.033-1.042.03-2.087a106.9,106.9,0,0,1,2.651-12.1c-1.037-2.953-3.215-5.382-4.639-5.64C103.991,279.1,102.322,292.141,105.952,298.917Z",
    transform: "translate(-93.723 -244.216)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M93.082,257.011a11.215,11.215,0,0,1,.047-2.285c0-.239,11.25-.481,12.155-.426a39.117,39.117,0,0,1,.121,6.6C97.5,261.257,93.307,258.4,93.082,257.011Z",
    transform: "translate(-86.064 -226.237)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M93.082,257.011a11.215,11.215,0,0,1,.047-2.285c0-.239,11.25-.481,12.155-.426a39.117,39.117,0,0,1,.121,6.6C97.5,261.257,93.307,258.4,93.082,257.011Z",
    transform: "translate(-86.064 -226.237)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M106.92,259.718c-1.7,0-3.517-.052-4.892-.1a4.907,4.907,0,0,1-.019-1.056c1.925.049,3.575.074,4.928.088C106.942,258.956,106.942,259.443,106.92,259.718Z",
    transform: "translate(-92.549 -229.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M95.594,259.434c-.723-.03-1.268-.063-1.523-.1a.154.154,0,0,1-.135-.143c0-.17-.036-.478-.036-.7a.16.16,0,0,1,.162-.16l1.565.047A6.131,6.131,0,0,0,95.594,259.434Z",
    transform: "translate(-86.685 -229.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M126.19,259.767a.154.154,0,0,1-.129.11c-.753.082-2.222.113-3.869.11a6.561,6.561,0,0,0-.041-1.067c2.2.016,3.525,0,3.935,0a.157.157,0,0,1,.157.14,1.958,1.958,0,0,1-.052.707Z",
    transform: "translate(-107.166 -229.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M132.58,396.87c.124,1.375.781,5.313.679,6.325.759.924,1.57,1,1.947.292s.275-6.143.275-6.143Z",
    transform: "translate(-114.728 -329.607)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M113.6,286.783c-.418-10.024-.025-16.307-.16-21.015l-9.309-.308c-.192,1.754.33,9.031,3.465,20.551,1.807,6.633,4.163,17.922,4.163,17.922l3.226-.506A83.013,83.013,0,0,0,113.6,286.783Z",
    transform: "translate(-94.074 -234.334)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M113.6,286.783c-.418-10.024-.025-16.307-.16-21.015l-9.309-.308c-.192,1.754.33,9.031,3.465,20.551,1.807,6.633,4.163,17.922,4.163,17.922l3.226-.506A83.013,83.013,0,0,0,113.6,286.783Z",
    transform: "translate(-94.074 -234.334)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M134.277,403.895a10.113,10.113,0,0,1-3.149.033c-.44-.162-.509-1.79-.509-1.79s3.407-.721,3.723-.479S134.277,403.895,134.277,403.895Z",
    transform: "translate(-113.307 -333.043)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M134.277,403.895a10.113,10.113,0,0,1-3.149.033c-.44-.162-.509-1.79-.509-1.79s3.407-.721,3.723-.479S134.277,403.895,134.277,403.895Z",
    transform: "translate(-113.307 -333.043)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M120.015,415.935s3.336-.982,3.575-2.3a.228.228,0,0,1,.275-.192l2.42.407a.314.314,0,0,1,.247.215l.19,2.357-1.51.022-.19-.159-1.177.176c-3.718.118-3.127.126-3.869-.083C119.861,416.07,120.015,415.935,120.015,415.935Z",
    transform: "translate(-105.559 -341.621)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M77.226,181.442c-1.312-.275-3.058-.591-4.345-.924a12.9,12.9,0,0,1-4.334-1.65,2.049,2.049,0,0,1-.357-3.058,4.023,4.023,0,0,1,1.411-.9,21.291,21.291,0,0,1,3.424-1.023c1.075-.245,2.258-.459,3.344-.654l.55-.1a1.358,1.358,0,0,1,.577-.036l.479,1.941c-.113.137-.349.173-.5.239l-.52.184c-1,.363-2.106.781-3.083,1.177a18.541,18.541,0,0,0-3.223,1.51.328.328,0,0,0,.061-.047,1.213,1.213,0,0,0,.3-.517,1.532,1.532,0,0,0-.113-1.144,1.144,1.144,0,0,0-.259-.33c-.025-.025,0-.014.025,0a38.115,38.115,0,0,0,5.167,1.163c.682.132,1.551.275,2.244.451l-.852,3.712Z",
    transform: "translate(-67.663 -167.36)",
    fill: "#e9bfbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M94.2,186.915l-1.8,2.923-1.281,2.082-1.1-.426-1.6-.622,1.1-4.722S92.861,186.659,94.2,186.915Z",
    transform: "translate(-82.712 -176.835)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M96.721,197.65c-.033.182-.072.355-.11.525l-1.282,2.082-1.1-.426A5.5,5.5,0,0,1,96.721,197.65Z",
    transform: "translate(-86.924 -185.172)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M100.94,170.465l1.375-1.925,1.754,2.219s-1.446,1.592-2.417.957Z",
    transform: "translate(-91.789 -164.067)",
    fill: "#eec1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M108.312,165.892l.484.883a.825.825,0,0,1-.212,1.037l-.93.729-1.754-2.219,1.287-.742a.825.825,0,0,1,1.125.313Z",
    transform: "translate(-95.385 -161.843)",
    fill: "#eec1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M107.52,194.4a29.382,29.382,0,0,0-.825,2.852c-.14.55-.256,1.086-.368,1.6-.124.575-.245,1.13-.38,1.691s-.291,1.128-.487,1.724a.217.217,0,0,1-.022.063c-.608,2.621-.146,2.533-.55,4.675,0,0,.275,1.254-.621,1.3-2.062.1-8.118,1.1-11.951-.6a1.322,1.322,0,0,1,.027-1.98c.275-3.451.176-8.987.927-11.825a5.052,5.052,0,0,1,.363-1.007,13.556,13.556,0,0,1,2.9-4.1,6.8,6.8,0,0,0,.952.116,39.577,39.577,0,0,1,8.052,1.554,3.1,3.1,0,0,1,1.977,1.9,3.061,3.061,0,0,1,.008,2.041Z",
    transform: "translate(-85.227 -178.748)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M120.211,175.49a11,11,0,0,0,.039,4.768.294.294,0,0,1-.132.313,4.805,4.805,0,0,1-3.71.938c-1.727-.3-1.881-1.075-1.375-1.6a.715.715,0,0,1,.275-.165c1.292-.476,1.507-1.391,1.287-2.01Z",
    transform: "translate(-101.822 -169.106)",
    fill: "#eec1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M124.576,175.5l-3.622,2.244a1.328,1.328,0,0,1-.154,1.194,2.637,2.637,0,0,0,1.9-.305,4.022,4.022,0,0,0,1.755-2.373C124.485,176.017,124.526,175.767,124.576,175.5Z",
    transform: "translate(-106.187 -169.113)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M110.91,162.313l-.825-2.046.1-.05a1.052,1.052,0,0,0-.2-.077.173.173,0,0,0-.168.038l-4.136,3.2a.275.275,0,0,0-.107.308l.825,2.1a.121.121,0,0,0,.066.072h0l.193.074.016-.143,4.125-3.168A.275.275,0,0,0,110.91,162.313Z",
    transform: "translate(-95.142 -157.972)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M107.063,166.032l-.825-2.1a.275.275,0,0,1,.107-.308l4.158-3.2c.1-.074.206-.058.242.038l.825,2.1a.275.275,0,0,1-.107.305l-4.155,3.2C107.208,166.142,107.1,166.126,107.063,166.032Z",
    transform: "translate(-95.621 -158.152)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M107.063,166.032l-.825-2.1a.275.275,0,0,1,.107-.308l4.158-3.2c.1-.074.206-.058.242.038l.825,2.1a.275.275,0,0,1-.107.305l-4.155,3.2C107.208,166.142,107.1,166.126,107.063,166.032Z",
    transform: "translate(-95.621 -158.152)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M107.614,166.358l-.825-2.074a.146.146,0,0,1,.055-.151l4.034-3.1c.047-.036.1-.027.118.019l.825,2.073a.143.143,0,0,1-.052.149l-4.034,3.1C107.686,166.413,107.634,166.405,107.614,166.358Z",
    transform: "translate(-96.027 -158.608)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1341",
    "data-name": "Group 1341",
    transform: "translate(14.534 2.961)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M121.2,164.79a.085.085,0,0,1-.041-.041l-.635-1.6a.074.074,0,1,1,.137-.055l.635,1.6a.074.074,0,0,1-.041.1A.094.094,0,0,1,121.2,164.79Z",
    transform: "translate(-120.513 -163.041)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M115.075,169.031a.627.627,0,0,1-.511.143.412.412,0,0,1-.3-.275.773.773,0,0,1,0-.487,1.07,1.07,0,0,1,.36-.528c.319-.245.679-.192.806.121a.957.957,0,0,1-.357,1.026Z",
    transform: "translate(-101.422 -163.48)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M114.588,170.115l-.025.019a.412.412,0,0,1-.3-.275.773.773,0,0,1,0-.487l.025-.022a.355.355,0,0,1,.467-.022.379.379,0,0,1,.137-.217c.116-.091.245-.069.291.044a.344.344,0,0,1-.129.366.217.217,0,0,1-.206.047A.671.671,0,0,1,114.588,170.115Z",
    transform: "translate(-101.422 -164.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M107.91,173.373l-.789-1.991a.094.094,0,0,1,.036-.1l.594-.454a.05.05,0,0,1,.08,0l.789,1.988a.091.091,0,0,1-.036.1l-.591.456C107.948,173.409,107.91,173.4,107.91,173.373Z",
    transform: "translate(-96.267 -165.711)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1342",
    "data-name": "Group 1342",
    transform: "translate(14.541 3.844)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M120.694,166.657a.033.033,0,0,1-.019-.019l-.132-.333a.038.038,0,0,1,.019-.049.041.041,0,0,1,.049.022l.132.333a.036.036,0,0,1-.022.047Z",
    transform: "translate(-120.539 -166.253)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M110.442,177.816c-.083.06-.171.047-.2-.03a.239.239,0,0,1,.091-.256c.08-.06.171-.047.2.03A.242.242,0,0,1,110.442,177.816Z",
    transform: "translate(-98.524 -170.558)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M109.767,176.088c-.08.061-.171.047-.2-.03a.234.234,0,0,1,.088-.253c.08-.063.17-.049.2.03A.234.234,0,0,1,109.767,176.088Z",
    transform: "translate(-98.037 -169.306)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M109.08,174.364c-.08.063-.168.049-.2-.03a.239.239,0,0,1,.088-.253c.082-.061.17-.047.2.03a.234.234,0,0,1-.091.253Z",
    transform: "translate(-97.539 -168.057)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M108.447,172.638c-.08.06-.171.047-.2-.03a.234.234,0,0,1,.088-.253c.08-.063.171-.049.2.03A.239.239,0,0,1,108.447,172.638Z",
    transform: "translate(-97.08 -166.804)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M106.3,202.557a33.083,33.083,0,0,1-.866,3.415.217.217,0,0,1-.022.063c-.608,2.621-.146,2.533-.55,4.675,0,0,.275,1.254-.621,1.3-2.062.1-8.118,1.1-11.951-.6a1.322,1.322,0,0,1,.028-1.98c.275-3.451.176-8.987.927-11.825a10.04,10.04,0,0,1,4.312-3.7s.1.674,1.317,1.136a5.2,5.2,0,0,0,3.605,0s1.5,1.169,2.409,4.515A7.041,7.041,0,0,0,106.3,202.557Z",
    transform: "translate(-85.205 -182.453)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M142.647,217.5c-.14.55-.256,1.086-.368,1.6-.124.575-.245,1.13-.38,1.691a8.074,8.074,0,0,1-.256-4.073,2.527,2.527,0,0,1,1,.781Z",
    transform: "translate(-121.187 -198.998)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M136.048,205.806a55.738,55.738,0,0,1,1.444,7.474,6.373,6.373,0,0,1-.137,2.824,9.275,9.275,0,0,1-1.05,1.779c-.737,1.042-1.546,2.027-2.362,2.992-.924,1.081-1.941,2.216-2.9,3.27-.126.124-.275.363-.467.426L129,223.331a1.567,1.567,0,0,1,.294-.55l.341-.512c.66-1,1.375-2.093,2-3.094a37.874,37.874,0,0,0,2.492-4.238v0a.207.207,0,0,0-.017.044v.025a.979.979,0,0,0-.016-.209c-.352-2.679-1.141-5.409-1.741-8.063l3.693-.935Z",
    transform: "translate(-112.132 -191.081)",
    fill: "#e9bfbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M140.16,194.47a8.469,8.469,0,0,1,3.377,1.554c1.65,1.485,1.947,6.825,1.947,6.825l-4.023,1.243-.954-2.725Z",
    transform: "translate(-120.223 -182.866)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M120.312,157.78s-1.491.809-1.183,3.377S122.856,158.9,120.312,157.78Z",
    transform: "translate(-104.946 -156.266)",
    fill: "#eec1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M120.312,157.78s-1.491.809-1.183,3.377S122.856,158.9,120.312,157.78Z",
    transform: "translate(-104.946 -156.266)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M123.4,161.56c-.5,1.939-.275,2.3-1.458,3.113-1.776,1.213-4.271,1.045-4.246-1.009.025-1.848.456-5.12,2.524-5.516a2.75,2.75,0,0,1,3.179,3.413Z",
    transform: "translate(-103.939 -156.496)",
    fill: "#eec1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M128.627,168.852c-.039.165-.116.165-.226.137s-.2-.066-.165-.234.157-.275.275-.253S128.666,168.684,128.627,168.852Z",
    transform: "translate(-111.572 -164.038)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M121.1,167.9c-.038.168-.118.168-.225.14s-.206-.066-.168-.234.16-.275.275-.253S121.139,167.734,121.1,167.9Z",
    transform: "translate(-106.114 -163.349)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M121.25,168.77a4.649,4.649,0,0,1-.8,1,.756.756,0,0,0,.6.223Z",
    transform: "translate(-105.934 -164.234)",
    fill: "#d4827d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M129.242,165.585a.093.093,0,0,0,.047,0,.1.1,0,0,0,.033-.137,1.006,1.006,0,0,0-.77-.5.1.1,0,0,0-.1.1.1.1,0,0,0,.1.1h0a.8.8,0,0,1,.605.4A.1.1,0,0,0,129.242,165.585Z",
    transform: "translate(-111.733 -161.464)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M119.587,164.479a.1.1,0,0,0,.093,0,.787.787,0,0,1,.707-.138.1.1,0,0,0,.129-.058.1.1,0,0,0-.061-.129.987.987,0,0,0-.894.162.1.1,0,0,0-.022.14A.143.143,0,0,0,119.587,164.479Z",
    transform: "translate(-105.261 -160.856)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M125.041,155.714a1.163,1.163,0,0,0-.533-.993c-.55-.3-2.148.275-3.025-.52a1.183,1.183,0,0,1,.825-1.818c1.6-.457,4.331.591,5.043,1.939a2.487,2.487,0,0,1,.206,2.271,1.356,1.356,0,0,0-.033-.613,1.837,1.837,0,0,1-.643,1.452Z",
    transform: "translate(-106.545 -152.275)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M134.981,166.408c-.954.429-.652-.49-.577-.577.319-.391.135-1-.088-1.842a2.335,2.335,0,0,1,.061-.96,5.294,5.294,0,0,1,1.779.129.844.844,0,0,1,.635.795A2.763,2.763,0,0,1,134.981,166.408Z",
    transform: "translate(-115.969 -160.055)",
    fill: "#eec1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M134.981,166.408c-.954.429-.652-.49-.577-.577.319-.391.135-1-.088-1.842a2.335,2.335,0,0,1,.061-.96,5.294,5.294,0,0,1,1.779.129.844.844,0,0,1,.635.795A2.763,2.763,0,0,1,134.981,166.408Z",
    transform: "translate(-115.969 -160.055)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M136.286,172.653a1.818,1.818,0,0,1-1.083.787c-.566.126-.762-.44-.528-1.007.212-.506.759-1.185,1.292-1.062S136.619,172.158,136.286,172.653Z",
    transform: "translate(-116.177 -166.109)",
    fill: "#eec1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M122.273,176.268a.058.058,0,0,1-.027-.107,2.7,2.7,0,0,1,1.27-.226.058.058,0,0,1,0,.116,2.643,2.643,0,0,0-1.213.209.063.063,0,0,1-.03.008Z",
    transform: "translate(-107.215 -169.424)",
    fill: "#263238"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataContact);
export default __webpack_public_path__ + "static/media/nodataContact.237f878dd7513bb2cf5298ffffaa56dd.svg";
export { ForwardRef as ReactComponent };